export default "__VITE_ASSET__Bvvl67Ql__"